module.exports = __webpack_public_path__ + "static/media/menu-button.7d91c5bc.svg";